import { InjectionToken, TypeProvider } from '@angular/core';

export const TenantHeader = 'X-Tenant-Id';
export const EnvironmentHeader = 'X-Environment-Id';

export const APP_CONFIG_SVC = new InjectionToken<TypeProvider>(
  'App Config Service'
);
